module.exports = __webpack_public_path__ + "img/Letter.90a8a4c6.svg";